import {
	getPopupElements,
	hasPopupElements,
	registerOutsideClickListener,
	registerPopupOptionListener,
	registerResizeListener,
	registerTriggerListeners,
	setInitialPopupState,
} from '../helpers/settingsPopup.js'

export default function handleSettingsPopup() {
	const popupElements = getPopupElements()
	const hasElements = hasPopupElements(popupElements)

	if (!hasElements) {
		return hasElements
	}

	const { popupElement, popupContent, triggerElements } = popupElements
	const didSetInitialState = setInitialPopupState(popupElement)
	const activeTrigger = { current: null }
	const switchTimeout = { current: null }

	const didRegisterTriggers = registerTriggerListeners({
		triggerElements,
		popupElement,
		popupContent,
		activeTrigger,
		switchTimeout,
	})
	const didRegisterOptions = registerPopupOptionListener({
		popupElement,
		activeTrigger,
	})
	const didRegisterOutside = registerOutsideClickListener({
		popupElement,
		triggerElements,
		activeTrigger,
	})
	const didRegisterResize = registerResizeListener({
		popupElement,
		activeTrigger,
	})

	const didInitPopup =
		didSetInitialState &&
		didRegisterTriggers &&
		didRegisterOptions &&
		didRegisterOutside &&
		didRegisterResize

	return didInitPopup
}
